export const PICKER_FUND_ID_STORAGE_KEY = 'picker.fundId';
export const PICKER_REQUEST_ID_STORAGE_KEY = 'picker.requestId';
export const PICKER_LEAD_ID_STORAGE_KEY = 'picker.leadId';
